export const REACT_QUERY_KEYS = Object.freeze({
    ADMIN_LOG: 'admin_log',
    ADMIN_OVERVIEW: 'admin_overview',
    AVAILABLE_PARTNER_COMPANIES: 'available_partner_companies',
    AVAILABLE_USER_ROLES: 'available_user_roles',
    COMMAND_OVERRIDES: 'fetch_overrides',
    COMMISSIONING_DATA: 'commissioning_data',
    COMMISSIONING_DEVICE_DATA: 'commissioning_device_data',
    COMMISSIONING_FINAL_VERIFICATION_STEP: 'commissioning_final_verification_step',
    COMMISSIONING_REPORT_OVERRIDES: 'commissioning_report_overrides',
    COMMISSIONING_REPORT_ALERTS: 'commissioning_report_alerts',
    CONTROL_LOOP_BUFFERED_STATE: 'cl_buffered_state',
    LIVE_ACTION_LIST: 'live_action_list',
    CURRENT_OVERRIDES: 'current_overrides',
    DEVICE_DETAIL: 'device_detail',
    FETCH_ARP: 'fetch_arp',
    GREEN_POWER_CERTIFICATE: 'green_power_certificate',
    JOURNAL_CTL: 'journal_ctl',

    CRM_OVERVIEW: 'elion_crm_overview',
    CRM_AVAILABLE_SITES: 'crm_available_sites',
    CRM_AVAILABLE_SMARTBOXES: 'available_smartboxes',
    CRM_AVAILABLE_CRMS: 'available_crms',
    CRM_SMARTBOX_OVERVIEW: 'crm_smartbox_overview',

    METERING_ACTUALS: "metering_actuals",
    METERING_FORECAST: "metering_forecast",
    METERING_HISTORICAL: "metering_historical",
    METERING_PEAK: "metering_peak",
    STATISTICS_GENERAL: "statistics_general",
    STATISTICS_BATTERY: "statistics_battery",
    STATISTICS_PRODUCTION: "statistics_production",
    STATISTICS_OUTAGES: "statistics_outages",
    STATISTICS_QUALITY_RATING: "statistics_quality_rating",
    IMBALANCE_EPEX: "imbalance_epex",
    SITE_ALERTS: "site_alerts",
    SITE_ALERTS_HISTORICAL: "site_alerts_historical",
    SITE_DATA: "site_data",
    SITE_MAXIMUM_PRODUCTION: "site_maximum_production",
    SITE_OVERVIEW: "site_overview",
    SITE_LIVE_DATA: "site_live_data",
    SITE_PRODUCT: "site_product",
    USER_OVERVIEW: "user_overview",
    USER_TECHNICAL_SUPPORT: "user_technical_support",
    DEVICE_METERING: "device_metering",
    DEVICE_METERING_LIVE: "device_metering_live",
    NODE_METERING: "node_metering",
    SITE_PROPERTIES: "site_properties",
    SUPPORTED_DEVICES: "supported_devices",
    OPTIMIZATION_PARAMETERS: "optimization_parameters",

    RESET_PASSWORD_SUBMIT: 'reset_password_submit',
    RESET_PASSWORD_REQUEST_LINK: 'reset_password_request_link',
    VALIDATE_RESET_PASSWORD_LINK: 'validate_reset_password_link',
    LANDING_PAGE_ERRORS: 'landing_page_errors',
    LANDING_PAGE_USER_ACTIVITY: 'landing_page_user_activity',
    LANDING_PAGE_SITE_ACTIVITY: 'landing_page_site_activity',
    LANDING_PAGE_SITE_FAVOURITES: 'landing_page_site_favourites',
    LANDING_PAGE_COMMISSIONING: 'landing_page_commissioning',
    LANDING_PAGE_INFO_STATISTICS: 'landing_page_info_statistics',
    LANDING_PAGE_SITE_STATISTICS: 'landing_page_site_statistics',
    LANDING_PAGE_QUALITY_RATING_STATISTICS: 'landing_page_quality_rating_statistics',

    FAQ: "faq",
    ELION_STATUS: "elion_status"
});